import React, { createContext } from 'react';
import { ProductScreen } from '../types';

export type ProductScreenType = {
  productScreen: ProductScreen;
  setProductScreen: React.Dispatch<React.SetStateAction<ProductScreen>>;
};

export const ProductScreenContext = createContext<ProductScreenType | null>(
  null
);
